import React, { useEffect, useRef, useState } from "react";
import { FolderPlus } from "@icon-park/react";
import { Button, Form, Modal, Progress, Upload } from "antd";
import axios from "axios";
import { toast } from "react-toastify";
import { DocBaseUrl } from "../../utils/configurable";
import { UploadOutlined } from "@ant-design/icons";

const initialState = {
  parent_id: "",
  folder_name: "",
  document_title: "",
  document_file_name: [],
};

const UploadDoc = (props) => {
  const {
    open,
    setOpen,
    loadings,
    fetchBriefFolderList,
    handleClose,
    handleLoading,
    triggerFileInput,
    selectedNodeData,
    Permission,
    uploadingFolder,
    userInfo,
    socket,
  } = props;

  const { Dragger } = Upload;

  const [fileForm] = Form.useForm();
  const notify = (error) => toast.error(error);
  const notifySuccess = (msg) => toast.success(msg);
  const [createFolderFile, setCreateFolderFile] = useState(initialState);
  const [pending, setPending] = useState(0);
  const [success, setSuccess] = useState(0);
  const [fileLoading, setFileLoading] = useState(false);
  const [progressFolder, setProgressFolder] = useState(0);
  const [dragFiles, setDragFiles] = useState([]);

  const handleChange = (name, value) => {
    setCreateFolderFile({ ...createFolderFile, [name]: value });
  };

  const createFile = async (value) => {
    const token = localStorage.getItem("docGridToken");
    setFileLoading(true);
    handleLoading("loadingFile", true);

    let remainingFiles = [...createFolderFile?.document_file_name].sort((a, b) => a.size - b.size);

    const chunkSize = 2 * 1024 * 1024;
    const maxParallelUploads = 2;
    let activeUploads = new Set();

    const uploadFile = async (file) => {
      if (!file) return;

      activeUploads.add(file.uid);
      // setCreateFolderFile((prev) => ({
      //   ...prev,
      //   document_file_name: prev.document_file_name.map((f) => (f.uid === file.uid ? { ...f, progress: 0 } : f)),
      // }));

      setDragFiles((prev) => prev.map((f) => (f.uid === file.uid ? { ...f, progress: 0, status: "uploading" } : f)));

      // const totalChunks = Math.ceil(file.originFileObj.size / chunkSize);

      // for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
      //   const start = chunkIndex * chunkSize;
      //   const end = Math.min(start + chunkSize, file.originFileObj.size);
      //   const chunk = file.originFileObj.slice(start, end);

      //   const formData = new FormData();
      //   formData.append("document_file_name", chunk, file.name);
      //   formData.append("document_title", file.name);
      //   formData.append("folder_id", selectedNodeData?.key);
      //   formData.append("share_with", 1);
      //   formData.append("chunkIndex", chunkIndex);
      //   formData.append("totalChunks", totalChunks);

      //   try {
      //     const response = await axios.post(
      //       `${DocBaseUrl}/genral-doctroal-add`,
      //       formData,
      //       {
      //         headers: {
      //           Authorization: token,
      //           "Content-Type": "multipart/form-data",
      //         },
      //         onUploadProgress: (progressEvent) => {
      //           const percentCompleted = Math.round(
      //             ((chunkIndex + 1) / totalChunks) * 100
      //           );
      //           setCreateFolderFile((prev) => ({
      //             ...prev,
      //             document_file_name: prev.document_file_name.map((f) =>
      //               f.uid === file.uid
      //                 ? { ...f, progress: percentCompleted }
      //                 : f
      //             ),
      //           }));
      //         },
      //       }
      //     );

      //     if (response?.data?.status !== "1") {
      //       // notify(`Upload failed for chunk ${chunkIndex + 1} of ${file.name}.`);
      //       console.error("Upload failed:", response?.data);
      //       return;
      //     } else {
      //       socket.emit("directory-action", {
      //         userName: userInfo?.userfullname,
      //         action: "Upload Document",
      //       });
      //     }
      //   } catch (error) {
      //     console.error("Upload error:", error.response?.data || error);
      //     notify(`Error uploading chunk ${chunkIndex + 1} of ${file.name}.`);
      //     return;
      //   }
      // }
      const formData = new FormData();
      formData.append("document_file_name", file.originFileObj, file.name);
      formData.append("document_title", file.name);
      formData.append("folder_id", selectedNodeData?.key);
      formData.append("share_with", 1);

      try {
        const response = await axios.post(`${DocBaseUrl}/genral-doctroal-add`, formData, {
          headers: {
            Authorization: token,
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            // setCreateFolderFile((prev) => ({
            //   ...prev,
            //   document_file_name: prev.document_file_name.map((f) =>
            //     f.uid === file.uid ? { ...f, progress: percentCompleted } : f
            //   ),
            // }));

            setDragFiles((prev) =>
              prev.map((f) => (f.uid === file.uid ? { ...f, progress: percentCompleted, status: "uploading" } : f))
            );
          },
        });

        if (response?.data?.status !== "1") {
          console.error("Upload failed:", response?.data);
          notify(`Upload failed for ${file.name}.`);
        } else {
          notifySuccess(`Upload Success`);
          // socket.emit("directory-action", {
          //   userName: userInfo?.userfullname,
          //   action: "Upload Document",
          // });
        }
      } catch (error) {
        console.error("Upload error:", error.response?.data || error);
        notify(`Error uploading ${file.name}.`);
      }

      //  File fully uploaded, remove from UI and start next file
      activeUploads.delete(file.uid);
      setSuccess((prev) => prev + 1);
      setPending((prev) => prev - 1);
      remainingFiles = remainingFiles.filter((f) => f.uid !== file.uid);

      setCreateFolderFile((prev) => ({
        ...prev,
        document_file_name: prev.document_file_name.filter((f) => f.uid !== file.uid),
      }));

      // 🚀 Immediately start another file if available
      if (remainingFiles.length > 0) {
        uploadFile(remainingFiles.shift());
      }
    };

    try {
      // Start uploading first two files
      while (activeUploads.size < maxParallelUploads && remainingFiles.length > 0) {
        uploadFile(remainingFiles.shift());
      }

      // Wait for all uploads to complete
      while (activeUploads.size > 0) {
        await new Promise((resolve) => setTimeout(resolve, 500));
      }

      setSuccess(0);
      setPending(0);
      setDragFiles([]);

      // ✅ Close the popup after all files are uploaded
      setOpen(false);
      fileForm.resetFields();

      await fetchBriefFolderList(selectedNodeData?.key);
    } catch (error) {
      console.error("Upload error:", error.response?.data || error);
      notify("Upload failed. Please try again.");
    } finally {
      setFileLoading(false);
      handleLoading("loadingFile", false);
    }
  };

  useEffect(() => {
    socket.on("directory-action", ({ userName, action }) => {
      // notifySuccess(`${userName} has ${action} a directory.`);
    });

    return () => {
      socket.off("directory-action");
    };
  }, []);

  return (
    <>
      <Modal
        title="Upload Document"
        open={open}
        className={fileLoading ? "bd_model_main uploadDoc_modal upload_overlay" : "bd_model_main uploadDoc_modal"}
        onCancel={() => {
          handleClose();
          fileForm.resetFields();
          setCreateFolderFile((pre) => ({ ...pre, document_file_name: [] }));
        }}
        footer={null}
      >
        <Form layout="vertical" name="control-ref" onFinish={createFile}>
          <Dragger
            name="document_file_name"
            multiple={true}
            beforeUpload={() => false}
            fileList={dragFiles}
            onChange={(info) => {
              const files = info.fileList.map((file) => ({
                uid: file.name + file.lastModified,
                name: file.name,
                status: file.status || "done",
                originFileObj: file.originFileObj,
                size: file.size,
                progress: file.progress || 0,
              }));

              const sortedFiles = files.sort((a, b) => a.size - b.size);

              setDragFiles(sortedFiles);
              handleChange("document_file_name", sortedFiles);
              setPending(sortedFiles.length);
              const selectedFile = sortedFiles[0]?.originFileObj;
              if (selectedFile) {
                const fileName = selectedFile.name;
                fileForm.setFieldsValue({ document_title: fileName });
              }
            }}
            onDrop={(e) => {
              console.log("Dropped files:", e.dataTransfer.files);
            }}
            itemRender={(originNode, file) => {
              const formatSize = (bytes) => {
                if (bytes < 1024) return `${bytes} B`;
                const kb = bytes / 1024;
                if (kb < 1024) return `${kb.toFixed(1)} KB`;
                const mb = kb / 1024;
                return `${mb.toFixed(1)} MB`;
              };

              return (
                <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    {/* keep Ant Design's original upload item */}
                    <div style={{ flex: 1 }}>{originNode}</div>

                    {/* your extra info: file size */}
                    <span
                      style={{
                        fontSize: 12,
                        color: "#999",
                        marginLeft: 10,
                        whiteSpace: "nowrap",
                      }}
                    >
                      {formatSize(file.size)}
                    </span>
                  </div>

                  {file.status === "uploading" && (
                    <Progress percent={file.progress || 0} size="small" status="active" showInfo={false} />
                  )}
                </div>
              );
            }}
          >
            <p className="ant-upload-drag-icon">
              <UploadOutlined />
            </p>
            <p className="ant-upload-text">Click or drag files to this area to upload</p>
            <p className="ant-upload-hint">Supports multiple files. Make sure each file name is valid.</p>
          </Dragger>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "20px",
            }}
          >
            <span>
              {pending != 0 && (
                <p style={{ color: "red" }}>
                  {" "}
                  Pending files : <span style={{ color: "black" }}>{pending}</span>
                </p>
              )}
            </span>
            <span>
              {success > 0 && (
                <p style={{ color: "green" }}>
                  {" "}
                  Uploaded files : <span style={{ color: "black" }}>{success}</span>
                </p>
              )}
            </span>
          </div>
          <div className="btn_flex">
            {Permission[0]?.is_update === "1" && (
              <>
                <Button className="newFolder_btn" onClick={triggerFileInput}>
                  <FolderPlus theme="outline" size="18" fill="#4d4d4d" strokeWidth={3} strokeLinecap="butt" />
                  <p>Upload Folder</p>
                </Button>

                {uploadingFolder === true && <Progress percent={progressFolder} style={{ width: "30%" }} />}
              </>
            )}
            <div style={{ display: "flex", gap: "15px" }}>
              <Button
                className="BG_ghostButton"
                disabled={loadings?.loadingFile}
                onClick={() => {
                  fileForm.resetFields();
                  setCreateFolderFile((pre) => ({
                    ...pre,
                    document_file_name: [],
                  }));
                  setPending(0);
                }}
              >
                Reset
              </Button>
              <Button
                className="BG_mainButton"
                key="submit"
                type="primary"
                htmlType="submit"
                loading={loadings?.loadingFile}
                disabled={loadings?.loadingFile}
              >
                Upload
              </Button>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};

export default UploadDoc;
